import { Observable, of } from 'rxjs';
import { BuysRepository } from '../domain/buy/repository';

import HttpClient from '../utils/http-client';

export class BuyRepositoryImplementation extends BuysRepository {
    getAllBuys(uid: string, cid: string | null, page: number, limit: number): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/buys?page=${page}&limit=${limit}`);
    }

    createBuy(uid: string, cid: string | null, data: any): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/buys`, data);
    }

    createBuyWithSupportDocument(uid: string, cid: string | null, data: any): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/buys/support-document`, data);
    }


    getBuyById(uid: string, cid: string | null, id: string): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/buys/items/${id}`);
    }

    delete(uid: string, cid: string | null, id: string): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.delete(`/buys/${id}`);
    }
}
